// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".arnie-codemirror[data-v-6bb170ca] {\n  height: calc(100vh - 250px);\n  width: 100%;\n}\n.status-width[data-v-6bb170ca] {\n  min-width: 8em;\n}", ""]);
// Exports
module.exports = exports;
